import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
var axios_instance = get_axios_instance(api_variables.SERVICE_TEMPLATE_DOWNLOAD);

const state = {}

const mutations = {}

const actions = {
  async downloadTemplate({ commit }, payload) {
      try {
        let res = await axios_instance.get(`/`, {
          params: {
            templateType: payload
          }
        });

        if (res.data.status) {
          const link = document.createElement("a");
          link.href = res.data.payload;
          link.setAttribute("download", payload + ".xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
      } catch (error) {
          throw errorHandler(error.response);
      }
  }
}

import organization from './modules/orgInfo.js'
import legal_entities from './modules/legal_entities.js';
import butypes from './modules/butypes.js';
import business_units from './modules/business_units.js';
import salary_grades from './modules/salary_grades.js';
import locations from './modules/locations.js';
import location_types from './modules/location_types.js';
import cost_centres from './modules/cost_centres.js';
import salary_bands from './modules/bands.js';
import designations from './modules/designations.js';
import levels from './modules/level.js'
import employees from './modules/employees.js';
import settings from './modules/settings/index.js';
import departments from './modules/departments.js';
import payFrequency from './modules/payfrequency.js';
import empCategory from './modules/empCategory.js';
import probationPeriod from './modules/probationPeriod.js';
import misc from './modules/misc.js';
import incrementSettings from './modules/incrementSettings.js';
import statutoryinfo from './modules/statutoryinfo/index.js';
import fbpBands from "./modules/fbpBands.js";
import importUdf from "./modules/importUdf.js";
import file_upload from "./modules/fileUpload.js";
import retirementSettings from "./modules/retirement.js";
import smtpSettings from "./modules/smtpSettings.js";
import paygroup from "./modules/paygroup.js";
import form24Q from "./modules/form24Q.js";
import loginSettings from "./modules/loginSettings.js";
import fbpEligibilityConfig from './modules/fbpEligibilityConfig.js';
import fbpConfigure from "./modules/fbpConfigure.js";
import perquisites from './modules/perquisites.js';

import ctcslab from "./modules/ctcslab.js";
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    modules: {
        legal_entities: legal_entities,
        butypes: butypes,
        business_units: business_units,
        salary_grades: salary_grades,
        locations: locations,
        location_types: location_types,
        cost_centres: cost_centres,
        organization: organization,
        salary_bands: salary_bands,
        designations: designations,
        levels: levels,
        statutoryinfo: statutoryinfo,
        employees: employees,
        settings: settings,
        departments: departments,
        payFrequency: payFrequency,
        empCategory: empCategory,
        probationPeriod: probationPeriod,
        misc: misc,
        fbpBands: fbpBands,
        importUdf: importUdf,
        form24Q: form24Q,
        incrementSettings: incrementSettings,
        file_upload: file_upload,
        retirementSettings: retirementSettings,
        smtpSettings: smtpSettings,
        paygroup: paygroup,
        loginSettings: loginSettings,
        fbpConfigure: fbpConfigure,
        ctcslab:ctcslab,
        fbpEligibilityConfig:fbpEligibilityConfig,
        perquisites: perquisites,
    }
};
